/* eslint no-console:0 */

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

// Bugsnag
import { bugsnag } from 'config/settings';

// Wimit UI
import { WimitUI } from '@wimit/ui/app/javascript/main';

WimitUI.start(bugsnag);

// Mount React components
import React from 'react'
import ReactDOM from 'react-dom'

var componentContext = require.context('components', true)

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-react-component]').forEach( (domContainer) => {
    var className = domContainer.getAttribute('data-react-component');

    var propsJson = domContainer.getAttribute('data-react-props');
    var props = propsJson && JSON.parse(propsJson);

    var component = componentContext('./' + className)['default'];
    var e = React.createElement(component, props);

    ReactDOM.render(e, domContainer);
  });
});
